import { CDN_PATH } from 'src/constants/common';

export const EXTRA_INSURANCE_FULL_DETAILS_LINK = `${CDN_PATH}/renins/insurance.pdf`;
export const EXTRA_INSURANCE_CONDITIONS_LINK = `${CDN_PATH}/renins/insurance_cancel.pdf`;
